import { jsx } from "react/jsx-runtime";
import MMenu from "@mui/material/Menu";
import styled from "@mui/material/styles/styled";
import React from "react";
import { useCurrentColor } from "../../shared/hooks/current-color";
const CustomMenu = styled(MMenu)((props) => {
  const { color, bg, sx } = props;
  return {
    "& > .MuiMenu-paper": {
      backgroundImage: "unset",
      minWidth: "120px",
      background: bg,
      backgroundColor: bg,
      color
    },
    ...sx ?? {}
  };
});
const Menu = React.forwardRef((props, ref) => {
  const {
    ctx,
    color,
    bg,
    passCtx,
    Provider
  } = useCurrentColor("elevation2", "contrast", true);
  const menuContent = /* @__PURE__ */ jsx(CustomMenu, { ref, ...props, color, bg });
  if (passCtx)
    return /* @__PURE__ */ jsx(Provider, { value: ctx, children: menuContent });
  return menuContent;
});
var Menu_default = Menu;
export {
  Menu_default as default
};
